<div class="control-errors">
  <p-message
    severity="error"
    text="{{ 'genericErrorMessages.required' | translate }}"
    @errorState
    *ngIf="invalid && errors?.required"
  ></p-message>

  <p-message
    severity="error"
    text="{{ 'genericErrorMessages.email' | translate }}"
    @errorState
    *ngIf="invalid && errors?.email"
  ></p-message>

  <p-message
    severity="error"
    text="{{ 'genericErrorMessages.errors?.confirmEmail' | translate }}"
    *ngIf="invalid && errors?.confirmEmail"
    @errorState
  ></p-message>

  <p-message
    severity="error"
    text="{{ 'genericErrorMessages.errors?.confirmPassword' | translate }}"
    *ngIf="invalid && errors?.confirmPassword"
    @errorState
  ></p-message>

  <p-message
    severity="error"
    text="{{ 'genericErrorMessages.onlyLetters' | translate }}"
    *ngIf="invalid && errors?.pattern && errors?.pattern?.requiredPattern === validationPatterns.ONLY_LETTERS"
    @errorState
  ></p-message>

  <p-message
    severity="error"
    text="{{ 'genericErrorMessages.url' | translate }}"
    *ngIf="invalid && errors?.pattern && errors?.pattern?.requiredPattern === validationPatterns.URL"
    @errorState
  ></p-message>

  <p-message
    severity="error"
    text="{{ 'genericErrorMessages.priceFormat' | translate }}"
    *ngIf="invalid && errors?.pattern && errors?.pattern?.requiredPattern === validationPatterns.PRICE"
    @errorState
  ></p-message>

  <p-message
    severity="error"
    text="{{ invalidByBackend.message }}"
    *ngIf="invalidByBackend.isInvalid"
    @errorState
  ></p-message>

  <p-message
    severity="error"
    text="{{ 'genericErrorMessages.maxlength' | translate: { value: errors?.maxlength?.requiredLength } }}"
    *ngIf="invalid && errors?.maxlength"
    @errorState
  ></p-message>

  <p-message
    severity="error"
    text="{{ 'genericErrorMessages.max' | translate: { value: errors?.max?.max } }}"
    *ngIf="invalid && errors?.max"
    @errorState
  ></p-message>

  <p-message
    severity="error"
    text="{{ 'genericErrorMessages.minlength' | translate: { value: errors?.minlength?.requiredLength } }}"
    *ngIf="invalid && errors?.minlength"
    @errorState
  ></p-message>

  <p-message
    severity="error"
    text="{{ 'genericErrorMessages.min' | translate: { value: errors?.min?.min } }}"
    *ngIf="invalid && errors?.min"
    @errorState
  ></p-message>

  <p-message
    severity="error"
    text="{{
      'genericErrorMessages.fileExtensionValidator'
        | translate: { value: errors?.fileExtensionValidator?.requiredExtensions }
    }}"
    *ngIf="invalid && errors?.fileExtensionValidator"
    @errorState
  ></p-message>

  <p-message
    severity="error"
    text="{{ 'genericErrorMessages.dateLowerThan' | translate: { value: errors?.dateLowerThan } }}"
    *ngIf="invalid && errors?.dateLowerThan"
    @errorState
  ></p-message>

  <p-message
    severity="error"
    text="{{ 'genericErrorMessages.dateHigherThan' | translate: { value: errors?.dateHigherThan } }}"
    *ngIf="invalid && errors?.dateHigherThan"
    @errorState
  ></p-message>

  <p-message
    severity="error"
    text="{{ 'genericErrorMessages.onlyWholeNumbers' | translate }}"
    *ngIf="invalid && errors?.pattern && errors?.pattern?.requiredPattern === validationPatterns.ONLY_WHOLE_NUMBERS"
    @errorState
  ></p-message>

  <p-message
    severity="error"
    text="{{ errors?.customMessage }}"
    *ngIf="invalid && errors?.customMessage"
    @errorState
  ></p-message>
</div>
